export class EntTransportCategoryFilter {
    page: number = 1;
    size: number = 30;
    name: string | null = null;
}
